import Seo from "@/components/Seo";
import { useLang, route } from "../i18n";
import { COMPANY } from "../data/config";
import PageHero from "../components/PageHero";
import FaqAccordion from "../components/FaqAccordion";
import FinalCta from "../components/FinalCta";

const Faq = () => {
  const { lang, t } = useLang();
  const f = t.faqPage;

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: f.items.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: { "@type": "Answer", text: item.a },
    })),
  };

  return (
    <>
      <Seo title={f.seo.title} siteName={COMPANY.name} description={f.seo.description} jsonLd={jsonLd} />
      <PageHero
        eyebrow={f.eyebrow}
        lines={[f.title]}
        breadcrumb={[{ label: t.nav.home, to: route(lang, "home") }, { label: t.nav.faq }]}
        testid="faq-hero"
      />
      <section className="bg-[#F4F0E8]" data-testid="faq-list">
        <div className="mx-auto max-w-3xl px-5 py-20 sm:px-8 sm:py-28">
          <FaqAccordion items={f.items} tone="light" testid="faq-page-accordion" />
        </div>
      </section>
      <FinalCta />
    </>
  );
};

export default Faq;
